import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import StockApi from './api/StockApi';
import BaseResponse from '../../app/BaseResponse';
import StockStatiticModel from './models/StockStatiticModel';
import Utility from '../../app/utility';
import { StockSearchSelector, setQueryItem, setQueryItemInit, setShowStockDetailModal, setStockStatitics, setTriggerRefreshStatitic, setTriggerRefreshStockDetail } from './reducers/StockSearchReducer';

const StockTable: React.FunctionComponent = () => {
    let dispatch = useDispatch();
    const stockSearchData = useSelector(StockSearchSelector);

    useEffect(() => {
        if (stockSearchData.stockStatitics.length == 0 || stockSearchData.triggerRefreshStatitic > 0) {
            dispatch(showLoading(true));
            StockApi.GetStockStatitics().then((response: BaseResponse<StockStatiticModel[]>) => {
                if (response.success) {
                    dispatch(setStockStatitics(response.data));

                    dispatch(showLoading(false));

                    dispatch(setTriggerRefreshStatitic(0));
                } else {
                    Utility.Alert.Error(response.message);
                    dispatch(showLoading(false));
                }
            }).catch((error) => {
                Utility.Alert.Error(error);
                dispatch(showLoading(false));
            })
        }
    }, [stockSearchData.triggerRefreshStatitic]);

    return <>
        <Table className="datatable Stock-table">
            <TableHead>
                <TableRow className="datatable-head">
                    <TableCell>No.</TableCell>
                    <TableCell>Items</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>Total Value</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    _.map(stockSearchData.stockStatitics, (stockStatitic, index) => {
                        return <TableRow
                            onClick={() => {
                                dispatch(setQueryItemInit(stockStatitic.items));
                                dispatch(setShowStockDetailModal(true));
                                dispatch(setTriggerRefreshStockDetail((new Date()).getTime()));
                            }}
                        >
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{stockStatitic.items}</TableCell>
                            <TableCell>{Math.round(stockStatitic.amount).toLocaleString('en-US')}</TableCell>
                            <TableCell>{Math.round(stockStatitic.totalValue).toLocaleString('en-US')}</TableCell>
                        </TableRow>
                    })
                }
            </TableBody>
        </Table>
    </>
};

export default StockTable;